import logisticsApi from "services/logisticsApi";

export type CoverageAreaDriverPayload = {
  driverId: string;
  priority: number;
};

type PutCoverageAreaDriversParams = {
  dealerId: string;
  coverageAreaId: string;
  drivers: CoverageAreaDriverPayload[];
};

type DriverSelection = {
  id: string;
};

export function buildCoverageAreaDriversPayload(
  driversToPersist: DriverSelection[],
): CoverageAreaDriverPayload[] {
  return driversToPersist.map((driver, index) => ({
    driverId: driver.id,
    priority: index,
  }));
}

export function putCoverageAreaDrivers({
  dealerId,
  coverageAreaId,
  drivers,
}: PutCoverageAreaDriversParams) {
  return logisticsApi.put(
    `/v1/dealers/${dealerId}/coverage-areas/${coverageAreaId}/drivers`,
    {
      dealerId,
      coverageAreaId,
      drivers,
    },
  );
}

export function saveCoverageAreaDrivers(params: {
  dealerId: string;
  coverageAreaId: string;
  driversToPersist: DriverSelection[];
}) {
  return putCoverageAreaDrivers({
    dealerId: params.dealerId,
    coverageAreaId: params.coverageAreaId,
    drivers: buildCoverageAreaDriversPayload(params.driversToPersist),
  });
}
